import { useState } from 'react';

import { message } from 'antd';
import { useParams } from 'react-router-dom';

import { setQrCodeStartTransaction, setQrCodeStopTransaction } from '../../../hooks/qrcodeOperations';

export const useQrCodeStartPage = () => {
  const MESSAGE_TIME = 10;

  const { chargeBoxId, connectorId }: any = useParams();

  const [isVerified, setIsVerified] = useState(false);
  const [recaptchaResponse, setRecaptchaResponse] = useState('');

  const recaptchaLoaded = (response) => {
    if (response) {
      setRecaptchaResponse(response);
      setIsVerified(true);
    }
  };

  // START
  const handleStart = async () => {
    if (!isVerified) {
      message.warning('Por favor verifique que você não é um robô!', MESSAGE_TIME);

      return;
    }

    const startResponse = await setQrCodeStartTransaction({
      chargeBoxId: chargeBoxId,
      connectorId: connectorId,
      token: process.env.REACT_APP_QRCODE_TOKEN as string,
      recaptchaResponse: recaptchaResponse
    });

    if (startResponse.type === 'success') {
      message.success('Comando START enviado.', MESSAGE_TIME);
    } else {
      message.warning('Não foi possível iniciar a recarga. Atualize a página e tente novamente.', MESSAGE_TIME);
    }
  };


  // STOP
  const handleStop = async () => {
    if (!isVerified) {
      message.warning('Por favor verifique que você não é um robô!', MESSAGE_TIME);

      return;
    }

    const stopResponse = await setQrCodeStopTransaction({
      chargeBoxId: chargeBoxId,
      connectorId: connectorId,
      token: process.env.REACT_APP_QRCODE_TOKEN as string
    });

    if (stopResponse.type === 'success') {
      message.success('Comando STOP enviado.', MESSAGE_TIME);
    } else {
      message.warning('Não foi possível parar a recarga.', MESSAGE_TIME);
    }
  };

  return {
    chargeBoxId,
    connectorId,
    handleStart,
    handleStop,
    isVerified,
    recaptchaLoaded
  };
};
